import { z } from "zod";

export const modulatorLastTemperaturePointDtoSchema = z.object({
  idCsModulator: z.number(),
  dateMeter: z.coerce.date().nullable(),
});

export type TModulatorLastTemperaturePointDto = z.infer<typeof modulatorLastTemperaturePointDtoSchema>;
